import React, {useEffect, useState} from 'react'
import {Container, Dropdown, Image, Menu as UiMenu, Responsive, Segment} from "semantic-ui-react";
import {NavLink} from "react-router-dom";
import {FiCamera, FiEdit, FiMenu, FiSearch, FiStar} from "react-icons/fi/index";
import {FormattedMessage} from "react-intl";
import {useSelector} from "react-redux";
import {fetchCategories} from "../../../../redux/actions";

const city = JSON.parse(localStorage.getItem('_CITY'));
const city_id = city['value'];
const token = sessionStorage.getItem('Token');

const goTo = (item, direct = 0) => {

    const {id, name, slug} = item;

    if (city_id === 7) {
        localStorage.setItem('_CITY', JSON.stringify({
            key: id,
            text: name,
            slug: slug,
            value: id
        }));
        window.top.location.href = '/';
        return;
    }

    window.top.location.href = `/categories/${id}/${slug}?id=${id}`;
};

const drawItems = (items, direct = 0) => {

    return items.map((item) => {

        const {id, name} = item;
        const key = `item-${id}`;

        if (direct) {

            return (
                <UiMenu.Item
                    key={key}
                >
                    <a href={'#'} onClick={() => goTo(item, direct)}>{name}</a>
                </UiMenu.Item>
            );
        }

        return (
            <Dropdown.Item
                key={key}
                text={`${name}`}
                onClick={() => goTo(item, 1)}
                className={'link dark'}
            />
        );
    });
};

const drawCategs = (categories, show, setShow, direct = 0) => {
    const trigger = (
        <UiMenu.Item style={{paddingTop: 17}}>
            <FiMenu style={{marginTop: -4}}/>
            <FormattedMessage id={city_id !== 7 ? "Categorias" : "Cidades"}/>
        </UiMenu.Item>
    );

    if (direct) {

        return (
            <>
                <UiMenu.Item onClick={() => setShow(!show)} className={'r14'}>
                    <FiMenu/><FormattedMessage id={city_id !== 7 ? "Categorias" : "Cidades"}/>
                </UiMenu.Item>
                {show && drawItems(categories, 1)}
            </>
        );
    }

    return (
        <Dropdown key={'menu-categories'} trigger={trigger} icon={false} wrapSelection={false}>
            <Dropdown.Menu>
                {drawItems(categories)}
            </Dropdown.Menu>
        </Dropdown>
    );
};

export const General = ({getWidth, subdomain}) => {

    const [categories, setCategories] = useState([]);
    const [show, setShow] = useState(false);

    const pathname = window.location.pathname;

    const cities = useSelector(state => state.Cities.results);

    useEffect(() => {

        if (categories.length) {
            return;
        }

        async function fetchCategoriesData() {

            const res = await fetchCategories(city.value);

            setCategories(res.data);
        }

        async function fetchCitiesData() {
            if (cities.success) {
                const options = cities.data.filter((o) => {
                    return (!o.indice && !o.future);
                });
                setCategories(options);
            }
        }

        // noinspection JSIgnoredPromiseFromCall
        if (city_id === 7) {
            // noinspection JSIgnoredPromiseFromCall
            fetchCitiesData();
        } else {
            // noinspection JSIgnoredPromiseFromCall
            fetchCategoriesData();
        }

    }, [city_id])

    return (
        <React.Fragment>
            <Responsive getWidth={getWidth} minWidth={Responsive.onlyTablet.minWidth}>
                <UiMenu secondary pointing inverted className={'main-menu'}>
                    <Container>
                        {
                            pathname !== '/' && <UiMenu.Item>
                                <NavLink to="/">
                                    <Image src={'/images/home.png'} className={'ui image'} height={21}/>
                                </NavLink>
                            </UiMenu.Item>
                        }

                        {
                            city_id !== 7 && <UiMenu.Item>
                                <NavLink to="/events">
                                    <FiStar/><FormattedMessage id="Eventos"/>
                                </NavLink>
                            </UiMenu.Item>
                        }

                        {drawCategs(categories, show, setShow)}

                        {
                            city_id !== 7 && <UiMenu.Item>
                                <NavLink to={`/city/${city.value}/${city.slug}/home/0/0`}>
                                    <FiCamera/><FormattedMessage id="A Cidade"/>
                                </NavLink>
                            </UiMenu.Item>
                        }

                        <UiMenu.Item>
                            <NavLink to={["europa", "italia"].includes(subdomain) ? `/columnists/${city.value}/${city.slug}/home/0/0` : `/columnists/${city.value}/${city.slug}`}>
                                <FiEdit/>
                                <FormattedMessage
                                    id={["europa", "italia"].includes(subdomain) ? "Famílias" : "Cult In Minas"}
                                />
                            </NavLink>
                        </UiMenu.Item>

                        <UiMenu.Item>
                            <NavLink to="/search">
                                <FiSearch/>
                                <FormattedMessage id="Pesquisar"/>
                            </NavLink>
                        </UiMenu.Item>

                        {
                            !["europa", "italia"].includes(subdomain) ?

                                <a href={"https://europa.inbh.com.br"}>
                                    <Image src={'/images/in-europa.png'} className={'europa'}/>
                                </a>
                                :
                                <a href={"https://inbh.com.br?v1"}>
                                    <Image src={'/images/in-bh.png'} className={'bh'}/>
                                </a>

                        }
                        {/*<UiMenu.Menu position={"right"}>*/}
                        {/*    {*/}
                        {/*        !["europa", "italia"].includes(subdomain) &&*/}
                        {/*        <NavLink to="/espaco-horizonte/home/0/0">*/}
                        {/*            <Image src={'/images/horizonte-white.png'} className={'horizonte'}/>*/}
                        {/*        </NavLink>*/}

                        {/*    }*/}
                        {/*</UiMenu.Menu>*/}
                    </Container>
                </UiMenu>
            </Responsive>
            <Responsive getWidth={getWidth} maxWidth={Responsive.onlyMobile.maxWidth}>
                <UiMenu vertical inverted widths={1} className={'main-menu'}>
                    {drawCategs(categories, show, setShow, 1)}

                    {show && (
                        <>
                            {
                                city_id !== 7 && <UiMenu.Item>
                                    <NavLink to="/events">
                                        <FiStar/>
                                        <FormattedMessage id="Eventos"/>
                                    </NavLink>
                                </UiMenu.Item>
                            }
                            {
                                city_id !== 7 && <UiMenu.Item>
                                    <NavLink to={`/city/${city.value}/${city.slug}/home/0/0`}>
                                        <FiCamera/>
                                        <FormattedMessage id="A Cidade"/>
                                    </NavLink>
                                </UiMenu.Item>
                            }

                            <UiMenu.Item>
                                <NavLink to={["europa", "italia"].includes(subdomain) ? `/columnists/${city.value}/${city.slug}/home/0/0` : `/columnists/${city.value}/${city.slug}`}>
                                    <FiEdit/>
                                    <FormattedMessage
                                        id={["europa", "italia"].includes(subdomain) ? "Famílias" : "Cult In Minas"}
                                    />
                                </NavLink>
                            </UiMenu.Item>

                            <UiMenu.Item>
                                <NavLink to="/search">
                                    <FiSearch/>
                                    <FormattedMessage id="Pesquisar"/>
                                </NavLink>
                            </UiMenu.Item>
                            {/*{*/}
                            {/*    !token && <UiMenu.Item  as={NavLink} to={'/users'}>*/}
                            {/*        Entrar*/}
                            {/*    </UiMenu.Item>*/}
                            {/*}*/}
                            {
                                !["europa", "italia"].includes(subdomain) ?
                                    <UiMenu.Item>
                                        <a href={"https://europa.inbh.com.br"}>
                                            <Image src={'/images/in-europa.png'} className={'europa'}/>
                                        </a>
                                    </UiMenu.Item> : <UiMenu.Item>
                                        <a href={"https://inbh.com.br?v1"}>
                                            <Image src={'/images/in-bh.png'} className={'bh'}/>
                                        </a>
                                    </UiMenu.Item>
                            }
                            {/*{*/}
                            {/*    subdomain !== 'italia' && <UiMenu.Item>*/}
                            {/*        <NavLink to="/espaco-horizonte/home/0/0">*/}
                            {/*            <Image src={'/images/horizonte-white.png'} className={'horizonte'}/>*/}
                            {/*        </NavLink>*/}
                            {/*    </UiMenu.Item>*/}
                            {/*}*/}
                        </>
                    )}
                    {
                        !show && (subdomain !== 'italia'
                            ? <div className={"brandsMenuMobile"}>
                            <div>
                                <NavLink to="/search">
                                    <FiSearch/>
                                </NavLink>
                            </div>
                            {/*<div>*/}
                            {/*    <NavLink to="/espaco-horizonte/home/0/0">*/}
                            {/*        <Image src={'/images/horizonte-white.png'} height={24}/>*/}
                            {/*    </NavLink>*/}
                            {/*</div>*/}
                            <div>
                                <a href={"https://europa.inbh.com.br"}>
                                    <Image src={'/images/in-europa.png'} height={24}/>
                                </a>
                            </div>
                        </div>
                            : <div className={"brandsMenuMobile"}>
                                <div>
                                    <NavLink to="/search">
                                        <FiSearch/>
                                    </NavLink>
                                </div>
                                <div>
                                    <a href={"https://inbh.com.br"}>
                                        <Image src={'/images/in-bh.png'} height={24}/>
                                    </a>
                                </div>
                            </div>
                        )
                    }
                </UiMenu>
            </Responsive>
        </React.Fragment>
    )
}